import { BrowserRouter } from "react-router-dom";
import { StoreProvider } from "./stores/StoreProvider";
import AppRoutes from "./routes/Routes";
import { ScrollProgress } from "./components/ScrollProgress";
import { CustomCursor } from "./components/CustomCursor";
import "./styles/globals.css";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollProgress />
      <CustomCursor />
      <StoreProvider>
        <AppRoutes />
      </StoreProvider>
    </BrowserRouter>
  );
}
